import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './utils/reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// EMERGENCY CACHE RESET - Force complete cache clearing and service worker unregistration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Unregister ALL service workers
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        console.log('Unregistering SW:', registration);
        await registration.unregister();
      }
      
      // Clear ALL caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames) {
          console.log('Deleting cache:', cacheName);
          await caches.delete(cacheName);
        }
      }
      
      console.log('All service workers and caches cleared');
      
      // Wait a moment then re-register the latest service worker
      setTimeout(() => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW re-registered: ', registration);
            // Force immediate activation
            if (registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      }, 1000);
      
    } catch (error) {
      console.error('Cache clearing failed:', error);
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 